/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-18 11:21:08
 * @Description: 
 */
import type { JackPotWinResponse } from '@/socket/jackpot/dto/jackpotSize.dto';

export const useJackPotSocket = () => {
    const rootPath = 'jackpot';
    const EMIT_JACKPOT_GETSUM = (data: any = {}, callback: any) => {
        socket.emit(`${rootPath}.getSum`, data, callback);
    };
    /**
     * 监听 jackpot 中奖信息，以便显示弹框
     * @param game 游戏名
     * @param callback 
     */
    const ON_WINJACKPOT = (
        game: string,
        callback: (winData: JackPotWinResponse) => void,
    ) => {
        // 接收到的数据示例：
        // 42["dicewinjackpot",{"jackpot":{"user":{"_id":70,"avatar":0,"lvl":1,"username":"User002x70"},"win_jackpot_amount":4314.83766269,"game":"dice","currency":"cny"}}] 
        const sApi = `${game}winjackpot`;
        socket.on(sApi, callback);
        return ()=>{
            socket.off(sApi, callback);
        }
    }
    /**
     * 获取jackpot表格历史数据
     * @param data 
     * @param callback 
     */
    const EMIT_JACKPOT_GETHISTORY = (data: any = {}, callback: any) => {
        socket.emit(`${rootPath}.getHistory`, data, callback);
    };
    /**
     * 获取jackpot分配比例
     * @param data 
     * @param callback 
     */
    const EMIT_GET_JACKPOT_CONFIG = (data: {game: string}, callback: any) => {
        socket.emit(`${rootPath}.getJackpotConfig`, data, callback)
    }
    return {
        EMIT_JACKPOT_GETSUM,
        ON_WINJACKPOT,
        EMIT_JACKPOT_GETHISTORY,
        EMIT_GET_JACKPOT_CONFIG
    };
};
